module.exports = __webpack_public_path__ + "static/img/activtiyImg.084f034.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activtiyImg.jpg
// module id = 01w0
// module chunks = 0